import React, { Fragment } from 'react';
import {
  Link,
} from "react-router-dom";
import { AppBar, Toolbar, Button, Grid } from '@material-ui/core/';
import { LogoutAction } from '../../actions';
import { connect } from 'react-redux';
import MenuComponent from './MenuComponent';
import PageTitle from "./PageTitle";
import './header.css'

function LiproHeader(props) {
  const userNAme = JSON.parse(localStorage.getItem('user'))
  const access_rights = JSON.parse(localStorage.getItem('access_right'))
  return (
    <AppBar className="liproHeader" position="static">
      <Toolbar>
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <img src="/lipro-logo.png" style={{ marginTop: '25px' }} width={100} alt="lirpo-log" />
          </Grid>
          <Grid item xs={6}>
            {
              props.is_logged_in && <Fragment>
                <h5 style={{
                  margin: '-10px',
                  textAlign: 'center',
                  height: '20px',
                  marginTop: '12px',
                  textTransform: 'capitalize'
                }}>
                  <PageTitle value={props.current_route} />
                </h5>
                <div className="d-flex">
                  {(Number(access_rights.projects_basedata_for_other) !== 0 || Number(access_rights.projects_basedata_for_own) !== 0 || Number(access_rights.projects_capacity_for_other) !== 0 ||
                    Number(access_rights.projects_capacity_for_own) !== 0 || Number(access_rights.projects_consultants_for_other) !== 0 ||
                    Number(access_rights.projects_consultants_for_own) !== 0 || Number(access_rights.projects_fee_for_other) !== 0 ||
                    Number(access_rights.projects_invoices_for_other) !== 0 || Number(access_rights.projects_invoices_for_own) !== 0 ||
                    Number(access_rights.projects_activity_for_other) !== 0 || Number(access_rights.projects_activity_for_own) !== 0 ||
                    Number(access_rights.projects_planning_for_other) !== 0 || Number(access_rights.projects_planning_for_own) !== 0 ||
                    Number(access_rights.time_reg_for_own) !== 0 || Number(access_rights.time_reg_other_consultants_other) !== 0 ||
                    Number(access_rights.projects_fee_for_own) !== 0) &&
                    <MenuComponent key="mc1" value="de" title="Dateneingabe" />
                  }
                  {(Number(access_rights.year_overview_consultants) !== 0 || Number(access_rights.year_overview_customers) !== 0 || Number(access_rights.year_overview_leads) !== 0 ||
                    Number(access_rights.year_overview_vacation) !== 0 || Number(access_rights.year_overview_resource_planning) !== 0 ||
                    Number(access_rights.year_overview_projects) !== 0 || Number(access_rights.year_overview_themes) !== 0 ||
                    Number(access_rights.months_plan) !== 0 || Number(access_rights.consultant_plan) !== 0 ||
                    Number(access_rights.archive) !== 0) &&
                    <MenuComponent key="mc2" value="op" title="Ausgaben/Übersichten" />
                  }
                  {(Number(access_rights.branches) !== 0 || Number(access_rights.classifications) !== 0 || Number(access_rights.consultant_categories) !== 0 ||
                    Number(access_rights.consultant_functions) !== 0 || Number(access_rights.countries) !== 0 || Number(access_rights.themes) !== 0 ||
                    Number(access_rights.public_holidays) !== 0 || Number(access_rights.system_settings) !== 0 ||
                    Number(access_rights.users) !== 0) &&
                    <MenuComponent key="mc3" value="ar" title="Administration" />
                  }
                </div>
              </Fragment>
            }
          </Grid>
          <Grid item xs={3}>
            {props.is_logged_in &&
              <Fragment>
                <div style={{
                  display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'
                }}>
                  {userNAme &&
                    <span style={{ display: 'inline-flex', padding: '6px 8px', marginTop: '20px' }}>{props.edited_user ? userNAme.loginname : userNAme.loginname}</span>
                  }
                  <Link to="/" className="MuiButtonBase-root MuiButton-root MuiButton-text menu-btn MuiButton-colorInherit MuiButton-label" style={{ marginTop: '20px', marginLeft: '20px' }} onClick={props.LogoutAction} color="inherit">
                    Abmelden
                  </Link>
                  <img src="/lischke-logo3.png" style={{ marginTop: '5px' }} width={120} alt="lischke-logo img" />
                </div>
              </Fragment>
            }
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar >
  )
}
const mapState = state => {
  const { is_logged_in, user } = state.login;
  const { current_route } = state.routing;
  const { edited_user } = state.usersData
  return {
    is_logged_in,
    user,
    current_route,
    edited_user
  }
}
export default connect(mapState, { LogoutAction })(LiproHeader);